export const light = {
  alternate: {
    light: '#fcfcfc',
    main: 'rgb(247, 249, 250)',
    dark: '#e8eaf6',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  formShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
  type: 'light',
  secondary: {
    main: '#5a7711', // #00cb79
    light: '#bcd4c4',
    dark: '#5a7713',
    contrastText: '#ffffff',
  },
  primary: {
    main: '#557794',
    light: 'rgb(166, 212, 250)',
    dark: '#557794',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  info: {
    main: '#3cc8b3',
  },
  success: {
    main: '#51c83c',
  },
  warning: {
    main: '#c8843c',
  },
  error: {
    main: '#c54343',
  },
  text: {
    primary: '#484848',
    secondary: '#5f5f5f',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    paper: '#fff',
    default: '#fff',
    level2: '#f5f5f5',
    level1: '#fff',
    footer: '#5f7335',
  },
  drawerWidth: 240,
  topBarHeight: 60,
};

export const corporateTheme = {
  alternate: {
    light: '#fcfcfc',
    main: 'rgb(247, 249, 250)',
    dark: '#e8eaf6',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  formShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
  type: 'light',
  secondary: {
    main: '#A8324C',
    light: '#C89494',
    dark: '#663535',
    contrastText: '#ffffff',
  },
  primary: {
    main: '#A8324C',
    light: '#E38994',
    dark: '#663535',
    contrastText: '#ffffff',
  },
  info: {
    main: '#3cc8b3',
  },
  success: {
    main: '#51c83c',
  },
  warning: {
    main: '#c8843c',
  },
  error: {
    main: '#c54343',
  },
  text: {
    primary: '#484848',
    secondary: '#5f5f5f',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    paper: '#fff',
    default: '#fff',
    level2: '#f5f5f5',
    level1: '#fff',
    footer: '#5f7335',
  },
  drawerWidth: 240,
  topBarHeight: 60,
};

// no need to change it until is going to be used
export const dark = {
  alternate: {
    main: '#2D3748',
    dark: '#24242b',
  },
  cardShadow: 'rgba(0, 0, 0, .11)',
  common: {
    black: '#000',
    white: '#fff',
  },
  type: 'dark',
  primary: {
    main: '#90caf9',
    light: 'rgb(166, 212, 250)',
    dark: '#557794',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  secondary: {
    light: '#ffb74d',
    main: '#f9b934',
    dark: '#f57c00',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  text: {
    primary: '#EEEEEF',
    secondary: '#AEB0B4',
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#1A202C',
    default: '#121212',
    level2: '#333',
    level1: '#2D3748',
    footer: '#18181f',
  },
};
